import { Pipe, PipeTransform } from '@angular/core';
declare var _:any;

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
  transform(data: Array<any>, arg?: string): any {
    if (!data) return;
    if (!arg) return data;

    let desc: boolean = arg[0].substr(0, 1) === '-';
    let argPure: string = desc ? arg[0].substr(1) : arg;
    let sortedArg: Array<any> = _.sortBy(data, argPure);

    return !desc ? sortedArg : sortedArg.reverse();
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/order-by.pipe.ts